import { orderQueryFilterFields, paginationFields, sortingFields } from 'next-common';

const orderFragment = `
fragment order on Order {
  id
  createdAt
  deliveredAt
  expiresAt
  actualExpiresAt
  status
  signedAt
  lead {
    orderType
    make
  }
  pimSnapshot {
    make
    series
  }
  customer {
    id
    customerType
    bosCustomer {
      id
      customerType
      firstName
      lastName
      organizationName
    }
  }

  user {
    ...user
  }
  vehicles {
    ...vehicle
  }
  reserveDetails {
    vehicleReserveStatus
  }
  equipments {
    type
    name
    sku
    pimSku
    pimId
    category
    priceIncludingVat
    priceExcludingVat
    marginPercentage
    marginAmount
    isHighlight
    unavailableForFactoryOrder
    vatCode
    retailPrice
    factoryCodeId
  }
  externalPricing {
    configId
  }
  soldByDealerId
  isEditOrder
}
`;
const vehicleFragment = `
  fragment vehicle on Vehicle {
    serialNo
  }
`;

const userFragment = `
  fragment user on User {
    firstName
    lastName
    employeeRoles {
      dealer {
        name
        dealerId
      }
    }
  }
`;

export const myOverviewOrderQuery = `
  query orderQuery($input: OrderQueryInput) {
    orderQuery(input: $input) {
      pagination {
        ${paginationFields}
      }
      sorting {
        ${sortingFields}
      }
      filters {
        ${orderQueryFilterFields}
      }
      results {
        ...order
      }
    }
  }
  ${orderFragment}
  ${userFragment}
  ${vehicleFragment}
`;
